import axios from "axios";

export default {
    getJigou() {
        return axios.get(`/home/Market/getJigou`);
    },

}